import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import {
  CatalogProductSchema,
  CatalogVariantSchema,
} from "../catalog/catalog-product-types";

const MarketplaceCartItemSchema_ = z.object({
  productId: zExt.objectId(),
  variantId: zExt.objectId(),
  quantity: z.number().int().positive(),
});

export const MarketplaceCartItemSchema: z.ZodType<MarketplaceCartItem> =
  MarketplaceCartItemSchema_;
export interface MarketplaceCartItem
  extends z.infer<typeof MarketplaceCartItemSchema_> {}

// Variant schema with inventory information
const CatalogVariantWithInventorySchema_ = CatalogVariantSchema.and(
  z.object({ available: z.number().min(0) }),
);

const MarketplaceCartItemWithProductSchema_ = MarketplaceCartItemSchema_.and(
  z.object({
    product: CatalogProductSchema,
    variant: CatalogVariantWithInventorySchema_,
  }),
);

export const MarketplaceCartItemWithProductSchema: z.ZodType<MarketplaceCartItemWithProduct> =
  MarketplaceCartItemWithProductSchema_;
export interface MarketplaceCartItemWithProduct
  extends z.infer<typeof MarketplaceCartItemWithProductSchema_> {}

const MarketplaceCartStatus = ["ACTIVE", "PENDING", "SUBMITTED"] as const;

const MarketplaceCartSchema_ = z.object({
  _id: zExt.objectId(),
  vendorId: z.string(),
  items: z.array(MarketplaceCartItemSchema),
  status: createEnum(MarketplaceCartStatus, {
    enumName: "MarketplaceCartStatus",
  }),
  order: zExt.objectId().optional(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const MarketplaceCartSchema: z.ZodType<MarketplaceCart> =
  MarketplaceCartSchema_;
export interface MarketplaceCart
  extends z.infer<typeof MarketplaceCartSchema_> {}

const MarketplaceCartWithProductsSchema_ = z.object({
  _id: zExt.objectId(),
  vendorId: z.string(),
  items: z.array(MarketplaceCartItemWithProductSchema),
  status: createEnum(MarketplaceCartStatus, {
    enumName: "MarketplaceCartStatus",
  }),
  order: zExt.objectId().optional(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const MarketplaceCartWithProductsSchema: z.ZodType<MarketplaceCartWithProducts> =
  MarketplaceCartWithProductsSchema_;
export interface MarketplaceCartWithProducts
  extends z.infer<typeof MarketplaceCartWithProductsSchema_> {}
